var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M33 15.56V17C33 25.8 25.8 33 17 33C8.2 33 1 25.8 1 17C1 8.2 8.2 1 17 1C19.24 1 21.48 1.48 23.56 2.44","stroke":"#0DB876","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M32.9992 4.19971L16.9992 20.1997L12.1992 15.3997","stroke":"#0DB876","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
